export const legalStatusCMVerbiage = [
    '',
    '',
    'DRAFT - Do Not Use',
    'PENDING - Legal Rights Clearance has not yet approved the rights for this title. Contact Legal Rights Clearance before taking any further action.',
    'PENDING – The media, territory and term for this title has been approved. However, approval is still pending for all other sections (e.g., editing, dubbing, advertising/publicity, sales & marketing, additional materials, packaging). Please contact the Rights Team before taking any further action in connection with the sections where approval is still pending.',
    'PRELIMINARY RIGHTS - The following rights are preliminary and subject to change without notice. Please contact Legal Rights Clearance before taking any further action.',
    'PRELIMINARY RIGHTS - Fox is in the process of acquiring the following rights, which are preliminary and subject to change without notice. Please contact Legal Rights Clearance before taking any further action.',
    'PROCESSING - Legal Rights Clearance is currently processing the rights for this title. Contact Legal Rights Clearance before taking any further action.',
];

export function stripHtml(html) {
    const tempDiv = document.createElement('div');
    tempDiv.innerHTML = html || '';
    return tempDiv.textContent || tempDiv.innerText || '';
}

export function truncate(input = '', truncateLength = 0) {
    return input.length > truncateLength ? input.substring(0, truncateLength) + '...' : input;
}

export function expandAll(treeData = []) {
    return treeData.map((node) => {
        const { children = [], ...rest } = node;
        return {
            ...rest,
            expanded: true,
            children: expandAll(children),
        };
    });
}

export function formatMemoTitleDisplay(title) {
    return (title ?? '').toLocaleUpperCase('en-US');
}
